<template>

  <div v-if="monitorVisible" style="margin-top:0px;">
    <!--流程监控-->
      <div class="middle" style="background-color: rgb(245, 247, 250);line-height: 35px;">
        <div class="pop" style="background-color: rgb(245, 247, 250);margin-left:10px;color: blue;">
          <span class="span-look" style="text-align:left;margin-left: 0px;color:#3b8cff;" @click="procTaskVisible = !procTaskVisible">流转记录</span><span
          class="span-look" @click="openPng();" style="color:#3b8cff;">查看流程图</span>
        </div>
      </div>
      <div v-if="procTaskVisible" style="margin-top:0px;height:100%" :space="200">
        <div class="el-steps el-steps--vertical " style="margin-top: 10px;">
          <div v-for="(item,key) in actList" :key="key" class="el-step is-vertical" style="flex-basis: 50%;">
            <div class="el-step__head "
                 style="color:#ffffff">
              <div class="el-step__line"
                   :style="backtofirst? 'margin-right: 0px;background-color:#CCCCCC':item.endTime == undefined?'margin-right: 0px;background-color:#CCCCCC':'margin-right: 0px;background-color:#ff9900'">
                <i class="el-step__line-inner" style="transition-delay: 0ms; border-width: 0px; height: 0%;"></i>
              </div>
              <div class="el-step__icon is-text"
                   :style="backtofirst? 'border-color:#CCCCCC;background-color:#cccccc':item.endTime == undefined?'border-color:#CCCCCC;background-color:#cccccc':'border-color:#ff9900;background-color:#ff9900'">
                <!---->
                <div class="el-step__icon-inner"><i class="sgbIcon icongouxuan"></i></div>
              </div>
              <div class="end_text" v-if="(actList.length - 1 == key) && item.endTime">结束</div>
            </div>
            <div class="el-step__main " style="padding-right: 10px;">
              <div class="step_lits">
                <div class="step_name">{{item.name}}</div>
                <div v-for="(assigner,index) in item.assignNodes" :key="index" style="position: relative;">
                  <div class="jr-step__main">
                    <div>
                      <img class="el-step-avatar" :src="avatar(assigner)">
                    </div>
                    <div class="jr-step-content">
                        <div class="jr-step-top_memo">
                          <div class="left_center">{{assigner.assignee}}</div>
                          <div class="right">
                              <div class="jr-step-content-header">
                                  <div class="jr-step-content-header-time">
                                    <!-- {{(assigner.startTime == undefined?'':assigner.startTime)+(assigner.endTime == undefined?'':'~ '+assigner.endTime)}} -->
                                    {{assigner.endTime == undefined?assigner.startTime:assigner.endTime}}
                                  </div>
                              </div>
                              <div class="jr-step-content-floor">
                                <div class="jr-step-content-sign"
                                    v-if="assigner.category !== '1'  && !assigner.start && assigner.startTime && assigner.endTime">
                                  签名：<img v-if="assigner.sign" class="jr-step-content-sign-img" :src="signPic(assigner)">
                                  <span v-else>{{assigner.assignee}}</span>
                                </div>
                                <div class="jr-step-content-sign"
                                    v-else-if="assigner.category !== '1'  && assigner.start && assigner.startTime && assigner.endTime">
                                    <span >签名：{{assigner.assignee}}</span>
                                </div>
                                <div class="jr-step-content-sign"
                                    v-else-if="assigner.category !== '1'  && assigner.startTime && !assigner.endTime">
                                  <span >审批人：{{assigner.assignee}}</span>
                                </div>
                                <div class="jr-step-content-sign"
                                    v-else-if="assigner.category === '1'  && assigner.startTime && assigner.assignee">
                                  <span >审阅人：{{assigner.assignee}}</span>
                                </div>
                              </div>
                          </div>
                        </div>
                      <div class="jr-step-content-comment" v-html="assigner.comment"></div>
                      <div style="color:#8b919e;" v-if="key !== 0"><i class="sgbIcon iconlinshi"></i>&nbsp;&nbsp;{{assigner.dueDate != undefined ? assigner.dueDate != '' ? calculateTime(assigner.startTime,assigner.endTime):calculateTime(assigner.startTime):''}}</div>
                    </div>
                  </div>
                  <div v-if="assigner.category == '1'" class="el-step-type">
                    抄送
                  </div>
                  <div v-if="assigner.category !== '1' && !assigner.start && assigner.startTime && assigner.endTime === undefined"
                      class="jr-step-run">
                    待审批
                  </div>
                  <div
                    v-if="assigner.category !== '1' && !assigner.start && assigner.startTime && assigner.endTime && (assigner.comment === undefined || (assigner.comment.indexOf('回退首环节')< 0 && assigner.comment.indexOf('回退上一环节')< 0))"
                    class="jr-step-end">
                    同&nbsp;&nbsp;&nbsp;意
                  </div>
                  <div
                    v-if="assigner.category !== '1' && !assigner.start && assigner.startTime && assigner.endTime && (assigner.comment && assigner.comment.indexOf('回退首环节')>-1)"
                    class="jr-step-reject">
                    驳&nbsp;&nbsp;&nbsp;回
                  </div>
                  <div
                    v-if="assigner.category !== '1' && !assigner.start && assigner.startTime && assigner.endTime && (assigner.comment && assigner.comment.indexOf('回退上一环节')>-1)"
                    class="jr-step-reject">
                    不同意
                  </div>
                </div>
                <div class="jr-step-content-copy" v-if="item.copyNodes.length > 0">
                  <div class="jr-step-content-copyto"><i v-if="item.copyNodes.length > 1" :class="showcopy[key]? 'el-icon-remove-outline':'el-icon-circle-plus-outline'" @click="showhidecopy(key)"></i>抄送给：</div>
                  <div class="jr-step-content-copyer">
                    <ul>
                      <li :class="item.copyNodes.length == 1 || !showcopy[key] ?'noborder':''">
                        <div class="name">
                          <div class="top"><img class="el-step-avatar" :src="avatar(item.copyNodes[0])"> <span>{{item.copyNodes[0].assignee}}</span></div>
                          <p v-if="item.copyNodes[0].endTime">{{item.copyNodes[0].comment}}</p>
                        </div>
                        <div class="status"  v-if="item.copyNodes[0].startTime"><span :class="item.copyNodes[0].endTime ? 'hasread':'noread'">{{item.copyNodes[0].endTime ? '已阅':'待阅'}}</span></div>
                        <div class="comfire_time"><span>{{countTime(item.copyNodes[0])}}</span></div>
                      </li>
                      <el-collapse-transition>
                          <div v-show="showcopy[key]">
                          <li v-for="(copyer,index) in item.copyNodes.slice(1)" :key="index">
                            <div class="name">
                              <div class="top"><img class="el-step-avatar" :src="avatar(copyer)"> <span>{{copyer.assignee}}</span></div>
                              <p v-if="copyer.endTime">{{copyer.comment}}</p>
                            </div>
                            <div class="status" v-if="copyer.startTime"><span :class="copyer.endTime ? 'hasread':'noread'">{{copyer.endTime ? '已阅':'待阅'}}</span></div>
                            <div class="comfire_time"><span>{{countTime(copyer)}}</span></div>
                          </li>
                        </div>
                      </el-collapse-transition>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    <!--<el-dialog
      :title="pngTitle"
      :visible.sync="pngVisible"
      width="30%"
      height="50%"
      style="z-index: 2100"
      center>
      <div style="width:100%;height:500px;text-align: center;overflow: auto;">

        <img style="width:200px;" width='100%' :src="pngSrc"/>
      </div>

    </el-dialog>-->

    <!--选择模板-->
    <div>
      <div class="select-box" v-if="pngVisible" @click.stop="pngVisible = !pngVisible">
        <div class="select" @click.stop="" style="width: 800px;height:620px;padding: 48px 20px 18px 20px;">
          <div class="title">
            <h4 style="margin:15px 22px 0;"><i></i>{{pngTitle}}</h4>
            <i  class="el-icon-close" @click.stop="pngVisible = !pngVisible" style="cursor: pointer; font-size: 20px;position: fixed; top: 15px;right: 15px;"></i>
          </div>
          <div class="select-center" style="height:550px;">
            <div id="wf-png-previewer" style="width:100%;height:100%;text-align: center;overflow: auto;">
              <!--<img style="width:200px;cursor: -webkit-zoom-in" width='100%' :src="pngSrc"/>-->
              <el-image
                :style="{width: imageWidth, height: 'auto'}"
                :src="pngSrc"
                :preview-src-list="srcList">
              </el-image>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>


</template>
<script>
import Template from '../../../components/index/template.vue';
import {getWorkflowTask} from '../../../api/workflow'

  export default {
    name: 'ProcessMonitor',
    props: ['model'],
    data() {
      return {
        monitorVisible:false,
        pngSrc: null,
        imageWidth: '200px',
        srcList:[],
        pngTitle: '流程图',
        pngVisible: false,
        defaultConfig: {},
        procTaskVisible: false,
        defaultAvatar: require('../../../assets/login/DefaultAvatar.png'),
        showProcUserDelete: false,//显示处理人的删除按钮
        showCopyUserDelete: false,//显示抄送人的删除按钮
        showSelectProcUser: false,//显示选择处理人
        showSelectCopyUser: false,//显示选择抄送人
        actList: [],
        businessKey:'',
        procDefId: '',//流程定义主键
        procInstId: '',//流程实例主键
        showcopy:[true,true,true,true,true,true,true,true],
        backtofirst:false, //是否驳回
      };
    },
    components: {},
    computed: {
      signPic(item) {
        return function (item) {
          let defaultUrl = ''// 'https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg'
          if (item['sign']) {
            defaultUrl = this.util.getBaseUrl() + '/api_v1/files/' + item['sign'] + '/look?ifThumb=false&access_token=' + this.sessionUtil.getAccessToken()
          }
          return defaultUrl
        }
      },
      avatar(item) {
        return function (item) {
          let defaultUrl = this.defaultAvatar
          if (item['avatar']) {
            defaultUrl = item['avatar']
          }
          return defaultUrl
        }
      }
    },
    created() {
      this.util.init(this);
      //console.info("processMonitor=======created========");
      //this.config =  this.defaultConfig;
    },
    activated() {
      //console.info("processMonitor=======activated========");
    },
    mounted() {

    },
    watch:{
      model:{
        handler(newVal,oldVal){
          /*if(newVal != null ){

            console.log('------',newVal,newVal.ifHasProcess,this.validUtil.isNotNull(newVal.businessKey))
          }
          if(newVal != null && newVal.ifHasProcess && this.validUtil.isNotNull(newVal.businessKey)){
            this.initProcess(newVal.businessKey)
          }*/
        },
        immediate:true
      }
    },
    methods: {
      countTime(copyer){
        if(copyer.endTime){
          return copyer.endTime;
        } else if(copyer.dueDate){
          if(copyer.dueDate.indexOf("分") > -1){
            return '已过：'+ copyer.dueDate.split('分')[0] + '分';
          } else {
            return '已过：0分';
          }
        } else {
          return ''
        }
      },
      getHoursDiff(dt1,dt2) {
          if(typeof(dt1)=="string") {
              dt1=new Date(dt1.replace(/-/,'/'));
              dt2=new Date(dt2.replace(/-/,'/'));
          }
          let res=dt2.getTime()-dt1.getTime();
          return res;
      },
      calculateTime(START_TIME,END_TIME){
        console.log(START_TIME+'------------'+END_TIME)
        // return 2;
        let oDate1 = new Date(START_TIME.replace(new RegExp(/-/gm) ,"/"));
        let oDate2 = new Date();
        let before_memo = '停留';
        if(END_TIME && END_TIME != 'undefined'){
          oDate2 = new Date(END_TIME.replace(new RegExp(/-/gm) ,"/"));
          before_memo = '用时';
        }
        let re=this.getHoursDiff(oDate1,oDate2);
        // console.log('======re========',re)
        //计算出相差天数  
        let days=Math.floor(re/(24*3600*1000))
        //计算出小时数  
        let leave1=re%(24*3600*1000)    //计算天数后剩余的毫秒数  
        let hours=Math.floor(leave1/(3600*1000))  
        //计算相差分钟数  
        let leave2=leave1%(3600*1000)        //计算小时数后剩余的毫秒数  
        let minutes=Math.floor(leave2/(60*1000)) 
        let myday = '';
        let myhours = '';
        if(days > 0) {
        myday = days + '天';
        myhours = hours+"小时"
        } else {
          if(hours > 0) {
            myhours = hours+"小时"
          }
        }
        return before_memo + myday + myhours +minutes+"分";
      },
      showhidecopy(key){
        this.showcopy[key] = !this.showcopy[key];
        this.$forceUpdate();
      },
      initProcess(businessKey) {
        console.log('--------initProcess----businessKey------',businessKey)
        if(this.validUtil.isNull(businessKey)){
          return
        }
        this.monitorVisible = true
        this.businessKey = businessKey
        this.actList = [];
        if (this.validUtil.isNotEmpty(businessKey)) {
          var _this = this;
          let params = {
            businessKey: businessKey,
            flag: false
          }
          getWorkflowTask(params).then(data => {
              if(data){
                data.forEach(item=>{
                  for(let v of item.assignNodes){
                    if (v.comment){
                      v.comment = v.comment.replace(new RegExp('/t/n', 'gm'), '<br/>')
                    }
                  }
                  for(let lit of item.copyNodes){
                    if (lit.comment){
                      lit.comment = lit.comment.replace(new RegExp('/t/n', 'gm'), '<br/>')
                    }
                  }

                })
                _this.actList = data;
                if(_this.actList[0].endTime){
                  _this.backtofirst = false;
                } else {
                  _this.backtofirst = true;
                }
              }
              
             _this.procTaskVisible = true
             console.log('--------getWorkflowTask---------', _this.actList)
          })
        }
      },
        // if (this.validUtil.isNotEmpty(businessKey)) {
        //   var _this = this;
        //   this.util.restGet('/api_v1/wf/tasks/historic', {
        //     businessKey: businessKey,
        //     flag: false
        //   }, function (res) {
        //     if (res.status == 200) {
        //       if (res.data && res.data.length>0) {
        //         _this.procTaskVisible = true
        //         let tempList = res.data.map(item =>{
        //                   if (item.comment){
        //                     item.comment = item.comment.replace(new RegExp('/t/n', 'gm'), '<br/>')
        //                   }
        //                   return item
        //                 });
        //         let approvalList = tempList.filter((item)=>{
        //           return item.category == '0'
        //         });
        //         for(let item of approvalList){
        //           item.copyer =[];
        //           let child = tempList.filter((item2)=>{
        //             return item2.taskDefKey == item.taskDefKey && item2.category == '1';
        //           });
        //           item.copyer = child;
        //         }
        //         _this.actList = approvalList;

        //         console.log('===========_this.actList=============',_this.actList)
        //       }else{
        //         // 隐藏父页面的流程监控
        //         if(_this.model.parent && _this.model.parent.hideProcessMonitor){
        //           _this.model.parent.hideProcessMonitor()
        //         }
        //       }

        //       // _this.actList.push({
        //       //     assignee: "管理员",
        //       //     category: "0",
        //       //     name: "结束",
        //       //     taskDefKey: "node4",
        //       // });
        //     }
        //   });
        // }
      openPng() {
        // 打开流程图
        if (this.validUtil.isNotEmpty(this.businessKey)) {
          this.pngSrc = this.util.getBaseUrl() + '/api_v1/wf/png?businessKey=' + this.businessKey + '&access_token=' + this.sessionUtil.getAccessToken()
          // console.info(this.pngSrc);
          this.srcList = [this.pngSrc]

          // 创建对象
          var img = new Image();

          // 改变图片的src
          img.src = this.pngSrc;
          var _this = this
          // 判断是否有缓存
          if(img.complete){
            // 打印
            // alert('from:complete : width:'+img.width+',height:'+img.height);
            _this.imageWidth = img.width
            _this.pngVisible = true
          }else{
            // 加载完成执行
            img.onload = function(){
              // 打印
              // alert('from:onload : width:'+img.width+',height:'+img.height);
              _this.imageWidth = img.width
              _this.pngVisible = true
            };
          }

        }
      }
    }
  };
</script>

<style scoped  lang="scss">

  .jr-step__main {
    width: 100%;
    display: flex;
    /*border: 1px dashed green;*/
    margin-bottom: 10px;
    // box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }

  .el-step-avatar {
    width: 35px;
    height: 35px;
    margin: 9px;
    border-radius: 5px;
  }

  .jr-step-content {
    display: flex;
    flex-flow: column;
    width: 100%;
  }
  .jr-step-top_memo{
    display: flex;
    height: 49px;
      .left_center{
        width: 50%;
        display: flex;
        align-items: center;
      }
      .right{
        width:50%;
        display: flex;
        flex-direction: column;
      }

  }
  .jr-step-content-header {
    width: 100%;
    padding-top: 5px;
    display: flex;
  }

  .jr-step-content-header-task {
    display: flex;
    width: 50%;
    padding-top: 0px;
  }

  .jr-step-content-comment {
    font-size: 10pt;
    color: #8b919e;
  }

  .jr-step-content-header-time {
    float: right;
    text-align: right;
    width: 100%;
    padding-right: 5px;
    color: #cccccc;
  }

  .jr-step-content-sign {
    text-align: right;
    padding-right: 57px;
    color: #909399;
  }

  .jr-step-content-sign-img {
    width: 65px;
    height: 25px;
    padding-bottom: 5px;
  }

  .el-step-type {
    position: absolute;
    width: 25px;
    left: 200px;
    font-size: 9pt;
    border: 1px solid #ff7e00;
    padding: 2px;
    height: 14px;
    line-height: 15px;
    top: 1px;
    color: #ff6000;
  }

  .jr-step-end {
    position: absolute;
    width: 36px;
    right: 260px;
    font-size: 9pt;
    border: 1px solid #67c23a;
    /* padding: 2px; */
    height: 14px;
    line-height: 15px;
    top: 6px;
    color: #67c23a;
    transform: rotate(-7deg);
    padding: 2px 10px 2px 10px;
    border-radius: 3px;
  }

  .jr-step-reject {
    position: absolute;
    width: 36px;
    right: 260px;
    font-size: 9pt;
    border: 1px solid red;
    /* padding: 2px; */
    height: 14px;
    line-height: 15px;
    top: 6px;
    color: red;
    transform: rotate(-7deg);
    padding: 2px 10px 2px 10px;
    border-radius: 3px;
  }

  .jr-step-run {
    position: absolute;
    width: 36px;
    right: 260px;
    font-size: 9pt;
    border: 1px solid #ff9900;
    /* padding: 2px; */
    height: 14px;
    line-height: 15px;
    top: 6px;
    color: #ff9900;
    transform: rotate(-7deg);
    padding: 2px 10px 2px 10px;
    border-radius: 3px;
  }
  .step_lits{
    min-height: 50px;
    width: 100%;
    margin-bottom: 10px;
    background: #ffffff;
    -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
    box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
      .step_name{
        padding-left: 10px;
        padding-top: 5px;
      }
}
  .jr-step-content-copy{
    display: flex;
    width: 100%;
    padding-bottom: 10px;
    padding-left: 10px;
    box-sizing: border-box;
     .jr-step-content-copyto{
       width: 100px;
       padding-top: 16px;
        i {
          margin-right: 10px;
         font-size: 15px;
        }
     }
     .jr-step-content-copyer{
        width: 100%;
        ul{
          width: 100%;
           .noborder{
             border-bottom: unset !important;
           }
           li{
              width: 100%;
              display: flex;
              justify-content: space-between;
              align-items: center;
              border-bottom: 1px dashed #cccccc;
                .name{
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                  align-items: left;
                  width: 60%;
                   img{
                     width: 30px;
                     height: 30px;
                   }
                  .top{
                   display: flex;
                  justify-content: left;
                  align-items: center;
                  }
                  p{
                      padding-left: 48px;
                      padding-bottom: 5px;
                      color: #8b919e;
                  }
                }
                .status{
                  width:15%;
                  text-align: right;
                   .hasread{
                      padding: 2px 5px 2px 5px;
                      border: #67c23a 1px solid;
                      color: #67c23a;
                      border-radius: 3px;
                      font-size:9pt;
                   }
                   .noread{
                      padding: 2px 5px 2px 5px;
                      border: #ff9900 1px solid;
                      color: #ff9900;
                      border-radius: 3px;
                      font-size:9pt;
                   }
                }
                .comfire_time{
                  width:25%;
                  text-align: right;
                  padding-right: 5px;
                  color: #cccccc;
                }
           }
        }
     }
  }
  .el-step.is-vertical .el-step__head{
    margin-left: 10px;
    width: 30px !important;
}
</style>

<style>
.end_text{
    position: absolute;
    top: 25px;
    left: 0px;
    color: #ff9900;
}
  #wf-png-previewer .el-image-viewer__mask{
    background-color: white;
    opacity: 1;
  }

</style>



// WEBPACK FOOTER //
// src/common/wf/v3/process-monitor.vue